export type TemplateModel = {
    id: string
    name: string
    parameter_format: string
    status: string
    category: string
    language: string
}

export type IntegracaoWhatsappModel = {
    integracaoId: number | null
    wabaid: string
    conta: string
    telefone: string
    ativo: boolean
    qualityRating: string
    verificationStatus: string
    phoneNumber: string
    verifiedName: string
    webhook: string
    templates: TemplateModel[]
}

export const IntegracaoWhatsappInicial: IntegracaoWhatsappModel = {
    integracaoId: null,
    wabaid: "",
    conta: "",
    telefone: "",
    ativo: false,
    qualityRating: "",
    verificationStatus: "",
    phoneNumber: "",
    verifiedName: "",
    webhook: "",
    templates: [],
}
